import { useI18n } from "@core/i18n/i18n";
import { useFormatFeedback } from "@domain/progress/hooks/use-feedback";
import { moodValues } from "@domain/progress/patient-feedback";
import styled from "@emotion/styled";
import { Button } from "@ui/components/buttons/button";
import { BaseDialog, DIALOG_SIZE } from "@ui/components/dialog/base-dialog";
import { row, stack } from "@ui/style";
import { DialogProps } from "primereact/dialog";
import React from "react";

export type MoodDetailsDialogProps = DialogProps;

export const MoodDetailsDialog: React.FC<MoodDetailsDialogProps> = props => {
	const { format } = useI18n();
	const { formatMood } = useFormatFeedback();

	return (
		<BaseDialog
			dismissableMask
			{...props}
			header={format("patientDetails.progress.moodModal.title")}
			width={DIALOG_SIZE.M}
			footer={
				<ButtonContainer>
					<Button onClick={props.onHide} label={format("patientDetails.progress.moodModal.button")} />
				</ButtonContainer>
			}
		>
			<DialogMessage>{format("patientDetails.progress.moodModal.description.v1_6")}</DialogMessage>
			<SpacedDialogMessage>
				{moodValues.map(v => {
					const moodWording = formatMood(v);
					return (
						<AlignCenteredItems key={v}>
							{format("patientDetails.progress.moodModal.moodListing.v2_1", {
								element: moodWording.icon,
								mood: moodWording.title,
							})}
						</AlignCenteredItems>
					);
				})}
			</SpacedDialogMessage>
		</BaseDialog>
	);
};
const DialogMessage = styled.div`
	white-space: pre-line;
`;

const SpacedDialogMessage = styled(DialogMessage)`
	${stack(8)}
`;

const ButtonContainer = styled.div`
	${row(24, "flexend")}
`;

const AlignCenteredItems = styled.div`
	${row(undefined, undefined, "center")};

	img {
		margin-right: 4px;
		width: 24px;
		height: 24px;
	}
`;
